<template>
    <div class="field-row">
        <label class="input-title">{{ $t('orders.select_order') }}</label>
        <multiselect
            v-model="selectedOrder"
            :options="orders"
            :close-on-select="true"
            label="display_name"
            track-by="id"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :select-label="$t('common.select')"
            :deselect-label="$t('common.remove_selection')"
            :placeholder="$t('orders.select_order')"
            :disabled="loading > 0 || !contract"
            :loading="loading > 0"
        >
            <template #noResult>
                <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
                <span v-if="!contract">{{ $t('contracts.select_contract') }}</span>
                <span v-else>{{ $t('common.no_results') }}</span>
            </template>
        </multiselect>
    </div>
</template>

<script>
import { restApi } from '../mixins/RestApiMixin'
import { orderMixin} from "../mixins/OrderMixin.js";

export default {
    name: 'RouteOptimizationOrderSelector',
    mixins: [restApi, orderMixin],
    props: {
        contract: {
            type: Object,
            default: null
        },
        modelValue: {
            type: Object,
            default: null
        },
        initialOrders: {
            type: Array,
            default: () => []
        }
    },
    emits: ['order-selected', 'loading', 'orders-loaded', 'update:modelValue'],
    data() {
        return {
            orders: this.initialOrders,
            selectedOrder: null,
            loading: 0
        }
    },
    watch: {
        contract: {
            handler(newContract, oldContract) {
                if (!newContract || (oldContract && newContract.id !== oldContract.id)) {
                    this.selectedOrder = null
                }
                if (newContract) {
                    this.fetchOrders()
                } else {
                    this.orders = []
                }
            },
            immediate: true,
        },
        selectedOrder(order) {
            this.$emit('order-selected', order)
            this.$emit('update:modelValue', order)
        },
        modelValue(newVal) {
            if (newVal !== this.selectedOrder) {
                this.selectedOrder = newVal
            }
        },
        initialOrders(newOrders) {
            if (Array.isArray(newOrders)) {
                this.orders = newOrders
            }
        },
        loading(isLoading) {
            this.$emit('loading', isLoading > 0)
        }
    },
    methods: {
        fetchOrders() {
            if (!this.contract) return

            this.loading++
            const params = {
                contract_ids: [this.contract.id],
                geometry_only: 1
            }

            this.restFetchParams(this.orderUrl, params, this.handleOrders)
        },
        handleOrders(response) {
            this.loading--
            if (response && response.data) {
                this.orders = response.data.map(order => ({
                    ...order,
                    display_name: order.id + ' - ' + this.getOrderStringWithInfo(order)
                }))
                this.$emit('orders-loaded', this.orders)
            }
        }
    }
}
</script>

<style scoped>
.input-title {
    font-size: .9em;
    color: #404041;
}

:deep(.multiselect__spinner) {
    width: 40px;
    height: 28px;
    background: #fff;
    right: 1px;
    top: 1px;
}

.invalid :deep(.multiselect__tags) {
    border-color: #dc3545;
}
</style>
